export const PARTNER_GROUP = [
    { name: 'Bình Minh', value: 'binh_minh' },
    { name: 'Vendor',    value: 'vendor' },
]

export const TYPE_PARTNER = [
    {
        name: 'In ép',
        value: 'print_partner',
    },
    {
        name: 'May',
        value: 'sewing_partner',
    },
    {
        name: 'Khác',
        value: 'other_partner',
    },
]

export const SEWING_PARTNER = 'sewing_partner'

// Thông tin nhận hàng in trên phiếu xuất kho giao may, chỉ áp dụng cho đối tác loại May
export const RECEIVER_FIELDS = [
    { key: 'receiver_name',    label: 'Người nhận hàng', placeholder: 'VD: Nguyễn Thị Giang',  maxLength: 100 },
    { key: 'receiver_phone',   label: 'Số điện thoại',   placeholder: 'VD: 0912 345 678',      maxLength: 20 },
    { key: 'receiver_address', label: 'Địa chỉ',         placeholder: 'Địa chỉ nhận hàng',     maxLength: 255 },
]

export const EMPTY_RECEIVER = RECEIVER_FIELDS.reduce((acc, f) => ({ ...acc, [f.key]: '' }), {})

export const TYPE_PARTNER_FILTER = [
    {
        name: 'In ép',
        value: 'print_partner',
    },
    {
        name: 'May',
        value: 'sewing_partner',
    },
    {
        name: 'Khác',
        value: 'other_partner',
    }
]

export const HIDDEN_PARTNER_FILTER = [
    {
        name: 'Ẩn',
        value: true,
    },
    {
        name: 'Hiện',
        value: false,
    }
]